import React from 'react';
import { useTranslation } from 'react-i18next';

const TimeoutPage = () => {
    const { t } = useTranslation();
    return (
        <div className="text-center">
            <div className="close-container">
                <div className="icon-prop timeout-img"></div>
            </div>
            <h1 className="not-authorized" aria-describedby="Oops, your browser timed out.">
                {t('Oops, your browser timed out.')}
            </h1>
            <h4 style={{'fontWeight': 400}}>{t('Close this page and go back to your app.')}</h4>
        </div>
        );
}
export default TimeoutPage;